<template>
  <extrato-cliente></extrato-cliente>
</template>

<script>
  import { mapMutations } from "vuex";
  import ExtratoCliente from '@/pages/extratocliente/ExtratoCliente'
  export default {
    name: 'home',
    components: {ExtratoCliente},
    data() {
      return {
        data: null,
        drawer: true,
        paddingLeft: 310
      }
    },
    mounted() {
      this.setTitulo('Home');
    },
    methods: {
      ...mapMutations(['setTitulo']),
    },

    watch: {
      drawer(newValue, oldValue) {
        if (newValue == true) {
          this.paddingLeft = 310;
        } else {
          this.paddingLeft = 0;
        }
      }
    },
  }
</script>

<style scoped>
  .input-trasparente >>> .v-input__slot {
    background: none;
  }
</style>
